import { useDeletePersonProfiles } from '@hakimo-ui/hakimo/data-access';
import { toast } from '@hakimo-ui/hakimo/util';
import { Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  profileIds: string[];
  profileCount: number;
  locationId: number;
  onClose: () => void;
  onSuccess: () => void;
}

export function DeleteProfilesModal(props: Props) {
  const { profileIds, profileCount, locationId, onClose, onSuccess } = props;

  const onDeleteSuccess = () => {
    toast(
      `${profileCount} profile${
        profileCount > 1 ? 's' : ''
      } deleted successfully`,
      {
        type: 'success',
      }
    );
    onSuccess();
    onClose();
  };

  const onDeleteError = (error: Error) => {
    toast(`Error deleting profiles: ${error.message}`, {
      type: 'error',
    });
  };

  const deleteMutation = useDeletePersonProfiles(
    onDeleteSuccess,
    onDeleteError
  );

  const onConfirmDelete = () => {
    deleteMutation.mutate({
      personProfileIds: profileIds,
      locationId: locationId,
    });
  };

  const actions = (
    <>
      <Button
        variant="error"
        onClick={onConfirmDelete}
        disabled={deleteMutation.isLoading}
        loading={deleteMutation.isLoading}
      >
        Delete
      </Button>
      <Button onClick={onClose} disabled={deleteMutation.isLoading}>
        Cancel
      </Button>
    </>
  );

  return (
    <Modal
      title="Delete Profiles"
      open={true}
      onClose={onClose}
      footer={actions}
    >
      <div className="w-[34rem] space-y-4 p-8">
        <p>
          Are you sure you want to remove {profileCount} profile
          {profileCount > 1 ? 's' : ''} from this location? Profiles will only
          be permanently deleted if they have no other location mappings.
        </p>
      </div>
    </Modal>
  );
}

export default DeleteProfilesModal;
